import { render } from "./BiodataTabComponent.vue?vue&type=template&id=629841a2"
import script from "./BiodataTabComponent.vue?vue&type=script&lang=js"
export * from "./BiodataTabComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\src\\Vue Project\\inalife-admin-dashboard\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__